export default {"src":"/_next/static/media/localisation.d939aa68.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};